import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';


import { openModalDetail, cleanErrors, sendingPurchase, finishPurchase, openModalFailPayment, openModalOperatorConfirmation } from '../../../actions/purchaseActions';
import { getUrlParams } from '../../../utils';
import matomoTracker from '../../../utils/matomo';

class ConfirmPurchase extends Component {
  finishPurchase = () => {
    const params = getUrlParams();
    const isOperatorSale = params.operator !== undefined;

    if (isOperatorSale && !this.props.hasConfirmedOperator) {
      this.props.openModalOperatorConfirmation();
      return;
    }
    this.props.sendingPurchase();
    this.props.finishPurchase()
      .then((response) => {
        if (response && response.reproved === true) {
          this.props.openModalFailPayment();
          return;
        }

        if (!this.props.purchase_is_valid) {
          this.props.history.push(`${this.props.location.pathname}${this.props.location.search}#${this.props.anchor}`);
        }
      })
      .catch((error) => {
        console.error('Erro ao finalizar compra:', error);
        alert('Ocorreu um erro ao processar sua compra. Tente novamente.');
      });

      matomoTracker.trackEvent('Checkout', 'SubmitOrder', 'Click')
  };

  render() {
    if (!this.props.plan[0]) return <div />;

    const plan = this.props.plan[0];

    const providers = this.props.providers;
    const provider = providers.filter((pr) => plan.provider_code === pr.code);

    let termsUrl = '';
    if (provider.length) termsUrl = provider[0].terms_url;

    return (
      <div className="confirm-purchase">
        <button
          className="finish-payment"
          data-cy="confirm-purchase"
          onClick={this.finishPurchase}
          data-perry-send-prospect-btn
        >
          Efetuar compra
        </button>

        <div className="text-payment">
          Ao clicar em "efetuar compra" você concorda com os{' '}
          <strong>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.segurospromo.com.br/shared/pdf/termos/termos-de-uso-e-condicoes-seguros-promo.pdf"
            >
              Termos de Uso,{' '}
            </a>
            <a target="_blank" href={termsUrl}>
              Condições Gerais do Seguro
            </a>{' '}
            e <button onClick={this.props.openModalDetail}>Cobertura do Produto</button>
          </strong>
        </div>
      </div>
    );
  }
}

const ConfirmPurchaseWrapper = (props) => {
  return <ConfirmPurchase {...props} />;
};

export default withRouter(
  connect(
    (state) => ({
      plan: state.search.plans,
      anchor: state.purchase.anchor,
      purchase_is_valid: state.purchase.purchase_is_valid,
      providers: state.global.providers,
      hasConfirmedOperator: state.purchase.hasConfirmedOperator,
    }),
    {
      openModalDetail,
      openModalFailPayment,
      cleanErrors,
      sendingPurchase,
      finishPurchase,
      openModalOperatorConfirmation,
    }
  )(ConfirmPurchaseWrapper)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/ConfirmPurchase.jsx